// Same hub style tokens as id-onboarding — kept inline per-app for now so
// the SPAs have no shared workspace package to depend on. Once @mf/ui ships
// a Theme provider this file goes away.
export const HUB_PAGE_CSS = `
:root {
  /* Neutral shadcn-style base (light / MoGu). applyBrandTheme() overrides
     these per resolved brand (MoGu light, OrX dark) before first paint. */
  --hub-bg: #ffffff;
  --hub-surface: #f5f5f5;
  --hub-card: #ffffff;
  --hub-ink: #0a0a0a;
  --hub-ink-soft: #737373;
  --hub-muted: #737373;
  --hub-line: #e5e5e5;
  --hub-accent: #171717;
  --hub-accent-600: #000000;
  --hub-on-accent: #fafafa;
  --hub-ring: #a3a3a3;
  --hub-danger: #dc2626;
  --hub-radius: 8px;
  --hub-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
  --hub-font:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Inter, "Helvetica Neue",
    Arial, sans-serif;
}
body {
  margin: 0;
  background: var(--hub-bg);
  color: var(--hub-ink);
  font-family: var(--hub-font);
  line-height: 1.5;
}
.hub-page-header { max-width: 760px; margin: 0 auto; padding: 48px 24px 16px; }
.hub-page-header h1 { margin: 0 0 8px; font-size: 28px; font-weight: 700; }
.hub-page-header p { margin: 0; color: var(--hub-ink-soft); font-size: 15px; }
.hub-explainer {
  max-width: 760px;
  margin: 24px auto 0;
  padding: 20px 24px;
  background: var(--hub-card);
  border: 1px solid var(--hub-line);
  border-radius: var(--hub-radius);
}
.hub-explainer h2 {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--hub-ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.hub-cta-row { max-width: 760px; margin: 28px auto 64px; padding: 0 24px; text-align: center; }
.hub-cta-button {
  display: inline-block;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  font-family: var(--hub-font);
  color: var(--hub-on-accent);
  background: var(--hub-accent);
  border: 1px solid var(--hub-accent);
  border-radius: var(--hub-radius);
  cursor: pointer;
  text-decoration: none;
}
.hub-cta-button:hover { background: var(--hub-accent-600); border-color: var(--hub-accent-600); }
.hub-cta-button.secondary { background: var(--hub-card); color: var(--hub-ink); border-color: var(--hub-line); }
.hub-cta-button.secondary:hover { background: var(--hub-surface); }
.hub-cta-button + .hub-cta-button { margin-left: 12px; }
.hub-banner {
  max-width: 760px;
  margin: 24px auto 0;
  padding: 14px 18px;
  border-radius: var(--hub-radius);
  font-size: 14px;
}
.hub-banner-info { background: var(--hub-card); color: var(--hub-ink); border: 1px solid var(--hub-line); border-left: 3px solid var(--hub-accent); }
.hub-banner-warn { background: var(--hub-card); color: var(--hub-ink-soft); border: 1px solid var(--hub-line); border-left: 3px solid var(--hub-ink-soft); }
.hub-identity {
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 24px 0;
}
.hub-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--hub-brand-accent, var(--hub-accent));
  color: var(--hub-on-accent);
  font-weight: 700;
  font-size: 18px;
  text-transform: uppercase;
  flex: none;
}
.hub-identity-meta { display: flex; flex-direction: column; line-height: 1.3; }
.hub-identity-label { font-size: 12px; color: var(--hub-muted); text-transform: uppercase; letter-spacing: 0.06em; }
.hub-identity-value { font-size: 15px; font-weight: 600; color: var(--hub-ink); }
.devices-table { width: 100%; max-width: 760px; margin: 24px auto; border-collapse: collapse; }
.devices-table th, .devices-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--hub-line);
  font-size: 14px;
  text-align: left;
}
.devices-table th { color: var(--hub-ink-soft); font-size: 12px; text-transform: uppercase; letter-spacing: 0.05em; }
.devices-state {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 11.5px;
  background: var(--hub-line);
  color: var(--hub-ink);
}
.devices-state-active { background: var(--hub-accent); color: var(--hub-on-accent); }
.devices-state-locked { background: var(--hub-surface); color: var(--hub-ink-soft); border: 1px solid var(--hub-line); }
.devices-state-disabled { background: transparent; color: var(--hub-danger); border: 1px solid var(--hub-danger); }
.dev-mfa-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  max-width: 760px;
  margin: 24px auto;
  padding: 0 24px;
}
.dev-mfa-button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 14px 18px;
  margin: 0;
}
.dev-mfa-button + .dev-mfa-button { margin-left: 0; }
.dev-mfa-result { max-width: 760px; margin: 24px auto; padding: 0 24px; font-size: 14px; }
`;

export function ensurePageStylesheet(): void {
  if (typeof document === "undefined") return;
  const id = "hub-page-stylesheet";
  if (document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = HUB_PAGE_CSS;
  document.head.appendChild(style);
}
